import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccessDataService {
  private pageNameSource = new BehaviorSubject<string>('');
  currentPageName = this.pageNameSource.asObservable();

  updatePageName(pageName: string) {
    this.pageNameSource.next(pageName);
  }

  calculateAveragePercentage(data) {
    return data.map(innerArray => {
      if (!innerArray || innerArray.length === 0) return 0;
      const sum = innerArray.reduce((acc, val) => acc + val, 0);
      const averagePercentage = sum / innerArray.length;
      return averagePercentage.toFixed(2);
    });
  }

  calculateAveragePercentageNoDecimal(data) {
    return data.map(innerArray => {
      if (!innerArray || innerArray.length === 0) return 0;
      const sum = innerArray.reduce((acc, val) => acc + val, 0);
      const averagePercentage = sum / innerArray.length;
      return averagePercentage.toFixed(0);
    });
  }

  accumulatorList(list) {
    let tempArray = [];
    if (!list || list.length === 0) {
      tempArray.push(0);
    } else {
      list.forEach(numbers => {
        if (!numbers) {
          return;
        }
        let accumulator = 0;
        numbers.forEach(currentValue => {
          accumulator += currentValue;
        });
        tempArray.push(accumulator);
      });
    }
    return tempArray;
  }

  setToFirstDayOfYear(date: Date): Date {
    let year = date.getFullYear();
    let nextMonth = new Date(year, 0, 1, 0, 0, 0);
    nextMonth.setDate(nextMonth.getDate());
    return nextMonth;
  }

  setToLastDayOfYear(date: Date): Date {
    let year = date.getFullYear();
    let nextMonth = new Date(year, 12, 0, 23, 59, 59);
    nextMonth.setDate(nextMonth.getDate());
    return nextMonth;
  }

  setToFirstDayOfMonth(date: Date): Date {
    let year = date.getFullYear();
    let month = date.getMonth();
    let nextMonth = new Date(year, month, 1, 0, 0, 0);
    nextMonth.setDate(nextMonth.getDate());
    return nextMonth;
  }

  setToLastDayOfMonth(date: Date): Date {
    let year = date.getFullYear();
    let month = date.getMonth();
    let nextMonth = new Date(year, month + 1, 0, 23, 59, 59);
    nextMonth.setDate(nextMonth.getDate());
    return nextMonth;
  }

  setToLastMinOfDay(date: Date): Date {
    let year = date.getFullYear();
    let month = date.getMonth();
    let day = date.getDate();
    let nextMonth = new Date(year, month, day, 23, 59, 59);
    nextMonth.setDate(nextMonth.getDate());
    return nextMonth;
  }

  setToFirstMinOfDay(date: Date): Date {
    let year = date.getFullYear();
    let month = date.getMonth();
    let day = date.getDate();
    let nextMonth = new Date(year, month, day, 0, 0, 0);
    nextMonth.setDate(nextMonth.getDate());
    return nextMonth;
  }

  buildViewSalesData = async (salesList) => {
    return salesList.docs.reduce((dataArray, salesData) => {
      const { product, year, month, count } = salesData;
      if (!dataArray) {
        dataArray = [];
      }
      dataArray.push({ product, year, month, count });
      return dataArray;
    }, []);
  }
}
